import React from 'react';

import { Stack, Divider, createStyles } from '@mantine/core';

import Form from './Form';
import Table from './Table';

const useStyles = createStyles(() => ({
  form: {
    marginBottom: '0.5rem',
  },
}));

function RegisterExpectationForm(): JSX.Element {
  const { classes } = useStyles();

  return (
    <Stack spacing='xs'>
      <Form className={classes.form} />
      <Divider my='xs' />
      <Table />
    </Stack>
  );
}

export default RegisterExpectationForm;
